import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { PiggyBank, Leaf, GraduationCap, Building2, ArrowRight } from "lucide-react";


export default function CrowdFundingModel() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 120,
      easing: "ease-out-cubic",
    });
  }, []);

  const items = [
    {
      icon: <Building2 className="w-6 h-6" />,
      title: "Infrastructure Sponsorship",
      text: "Fund the development of critical infrastructure like storage, energy systems, and water facilities.",
    },
    {
      icon: <PiggyBank className="w-6 h-6" />,
      title: "Community Asset Co-Funding",
      text: "Collaborate with others to co-own and finance shared assets that benefit entire communities.",
    },
    {
      icon: <GraduationCap className="w-6 h-6" />,
      title: "Education Programs",
      text: "Support training centers and youth innovation programs that empower local talent.",
    },
    {
      icon: <Leaf className="w-6 h-6" />,
      title: "Restoration Initiatives",
      text: "Invest in environmental regeneration projects that restore land and ecosystems.",
    },
  ];

  return (
    <section className="w-full bg-[#0F172A] text-white py-20 px-6 md:px-12 lg:px-20">
      <div className="max-w-[1400px] mx-auto">
        {/* HEADER */}
        <div data-aos="fade-up" className="mb-16 max-w-3xl">
          <p className="text-sm tracking-[0.3em] text-[#94A3B8] mb-4">
            FUNDING MODEL
          </p>

          <h2
            data-aos="fade-up"
            data-aos-delay="100"
            className="text-3xl md:text-5xl font-semibold leading-tight mb-6"
          >
            Crowdfunding & Impact Investment Model{" "}
          </h2>

          <p
            data-aos="fade-up"
            data-aos-delay="200"
            className="text-[#CBD5F5] text-base md:text-lg leading-relaxed"
          >
            The initiative is supported through a blended funding approach that
            enables individuals, partners, and institutions to sponsor
            infrastructure, co-finance community assets, and invest in education
            and ecosystem restoration programs. This model channels capital
            directly into measurable, on-the-ground impact with tangible
            environmental and community outcomes.
          </p>
        </div>

        {/* CTA STRIP */}
        <div
          data-aos="fade-up"
          className="mt-20 bg-gradient-to-r from-[#1E293B] to-[#1E293B] p-8 md:p-12 rounded-3xl flex flex-col md:flex-row items-center justify-between gap-6"
        >
          <div className="max-w-xl">
            <h4 className="text-xl md:text-2xl font-semibold mb-2 text-white">
              Turning Capital into Measurable Impact{" "}
            </h4>

            <p className=" text-sm md:text-base">
              Every contribution is channelled directly into community-driven
              action—supporting climate-smart infrastructure, education and
              skills development, and environmental sustainability initiatives
              that deliver visible and lasting outcomes at the local level.{" "}
            </p>
          </div>

          <div className="mt-10">
              <a
                href="https://www.linkedin.com/company/anna-foundations/"
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-green-500 hover:bg-white transition-all duration-300 text-black px-8 py-4 rounded-full flex items-center gap-3 tracking-wide w-fit shadow-lg"
              >
            Sponsor a Project

                <span className="group-hover:translate-x-1 transition-transform duration-300">
                  <ArrowRight size={18} />
                </span>
              </a>
            </div>
        </div>
      </div>
    </section>
  );
}
